<template>
  <div
    v-bind:class="{ 'py-5': $root.$children[0].isAdminstrationMode }"
    :key="'news' + $root.$children[0].viewComponentKey"
    style=""
  >
    <b-col cols="12">
      <div>
        <b-row>
          <b-col cols="12">
            <h2 id="navigation-title"></h2>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <div id="renderer"></div>
          </b-col>
        </b-row>
      </div>
    </b-col>
  </div>
</template>

<script>
import config from "../config/config.js";
import "../components/formio/SummaryComponent.js";
import axios from "axios";
import moment from "moment";
import { Formio } from "formiojs";
import Vue from "vue";
const compiler = require("vue-template-compiler");

export default {
  data: function () {
    return {
      defItem: {},
      currentForm: null,
      _sessionId: null,
      summaryTemplateHtml: null,
    summaryTemplateComponent: null,
    };
  },

  mounted() {
    let self = this;

    // =====================================================
    // Live-CSS für Signup laden
    // =====================================================
    const signupCssId = "ozg-signup-live-css";

    if (!document.getElementById(signupCssId)) {
      const link = document.createElement("link");
      link.id = signupCssId;
      link.rel = "stylesheet";
      link.href = process.env.BASE_URL + "signup-live.css?v=" + Date.now();
      document.head.appendChild(link);
    }

    // =====================================================
    // Technische Session starten
    // =====================================================
   // =====================================================
// Signup läuft öffentlich: keine authenticateBySession,
// keine form_sessions, kein technischer JWT
// =====================================================
try {
  localStorage.removeItem("ozgJwt");
  delete axios.defaults.headers.common["Authorization"];
} catch (e) {
  console.warn("[SIGNUP AUTH] alter Token konnte nicht entfernt werden:", e);
}

self._sessionId = null;
window.sessionId = null;

const signupFormId = 52;

        

          // =====================================================
          // Basis-Kontext für Form.io / SummaryComponent
          // =====================================================
          let formCommunityDTO = {
            formId: signupFormId,
            communityIdentifier: null,
          };

          window.formCommunityDTO = formCommunityDTO;
          window.formId = signupFormId;
          window.summary = "";
          window.draftSubmission = { data: {} };

          axios
            .get(config.API_URL + "/api/form/" + signupFormId)
            .then((response) => {
              console.log("SIGNUP /api/form response:", response.data);

              if (!response.data || !response.data.value) {
                console.error(
                  "SIGNUP: Formular enthält kein value-Feld:",
                  response.data
                );

                self.$root.$children[0].showMessage(
                  "Fehler",
                  "Das Registrierungsformular konnte nicht geladen werden.",
                  "danger"
                );

                return;
              }

              let parsedValue;

              try {
                parsedValue =
                  typeof response.data.value === "string"
                    ? JSON.parse(response.data.value)
                    : response.data.value;
              } catch (e) {
                console.error(
                  "SIGNUP: response.data.value ist kein gültiges JSON:",
                  e
                );

                self.$root.$children[0].showMessage(
                  "Fehler",
                  "Das Registrierungsformular ist fehlerhaft gespeichert.",
                  "danger"
                );

                return;
              }

              console.log("SIGNUP parsed form value:", parsedValue);
              console.log("SIGNUP parsedValue keys:", Object.keys(parsedValue));

              // =====================================================
              // Form.io Definition robust ermitteln
              // =====================================================
              self.defItem =
                parsedValue.formDefintion ||
                parsedValue.formDefinition ||
                parsedValue.definition ||
                parsedValue.form ||
                parsedValue;

              // Falls die Definition selbst nochmal als String gespeichert ist
              if (typeof self.defItem === "string") {
                try {
                  self.defItem = JSON.parse(self.defItem);
                } catch (e) {
                  console.error(
                    "SIGNUP: defItem konnte nicht geparst werden:",
                    e
                  );

                  self.$root.$children[0].showMessage(
                    "Fehler",
                    "Die Registrierungsformular-Definition ist fehlerhaft gespeichert.",
                    "danger"
                  );

                  return;
                }
              }

              // Fallback: falls display fehlt
              if (!self.defItem.display) {
                self.defItem.display = "wizard";
              }

              // Komponenten kommen ggf. als JSON-String
              if (typeof self.defItem.components === "string") {
                try {
                  self.defItem.components = JSON.parse(self.defItem.components);
                } catch (e) {
                  console.error(
                    "SIGNUP: components konnte nicht geparst werden:",
                    e
                  );

                  self.$root.$children[0].showMessage(
                    "Fehler",
                    "Die Komponenten des Registrierungsformulars sind fehlerhaft gespeichert.",
                    "danger"
                  );

                  return;
                }
              }

              if (
                typeof self.defItem.settings === "string" &&
                self.defItem.settings.trim() !== ""
              ) {
                try {
                  self.defItem.settings = JSON.parse(self.defItem.settings);
                } catch (e) {
                  self.defItem.settings = {};
                }
              }

              if (
                typeof self.defItem.properties === "string" &&
                self.defItem.properties.trim() !== ""
              ) {
                try {
                  self.defItem.properties = JSON.parse(self.defItem.properties);
                } catch (e) {
                  self.defItem.properties = {};
                }
              }

              if (!Array.isArray(self.defItem.components)) {
                console.error(
                  "SIGNUP: Form.io Definition hat keine gültigen components:",
                  self.defItem
                );

                console.error("SIGNUP: parsedValue vollständig:", parsedValue);

                self.$root.$children[0].showMessage(
                  "Fehler",
                  "Das Registrierungsformular enthält keine gültigen Komponenten.",
                  "danger"
                );

                return;
              }

              console.log("SIGNUP finale Form.io Definition:", self.defItem);

              const signupSummaryTemplateId = 24;

axios
  .get(config.API_URL + "/api/template/" + signupSummaryTemplateId)
  .then((templateResponse) => {
    try {
      if (
        templateResponse &&
        templateResponse.data &&
        templateResponse.data.definition
      ) {
        const parsedTemplateDefinition =
          typeof templateResponse.data.definition === "string"
            ? JSON.parse(templateResponse.data.definition)
            : templateResponse.data.definition;

        self.summaryTemplateHtml = parsedTemplateDefinition.html || null;

        console.log(
          "[SIGNUP SUMMARY TEMPLATE] Template geladen:",
          templateResponse.data.templateId,
          templateResponse.data.title
        );
      }
    } catch (e) {
      console.warn(
        "[SIGNUP SUMMARY TEMPLATE] Template konnte nicht geparst werden:",
        e
      );

      self.summaryTemplateHtml = null;
    }
  })
  .catch((e) => {
    console.warn(
      "[SIGNUP SUMMARY TEMPLATE] Template 24 konnte nicht geladen werden:",
      e
    );

    self.summaryTemplateHtml = null;
  });

              // =====================================================
              // Form.io URLs setzen
              // =====================================================
              Formio.setBaseUrl(config.API_URL + "/api/formManager");
              Formio.setProjectUrl(config.API_URL + "/api/formManager");

              // =====================================================
              // WICHTIG: SummaryComponent-Kontext wie im Widget vorbereiten
              // =====================================================
              window.formDefinition = self.defItem;

              window.currentForm = {
                ...parsedValue,
                formId: signupFormId,
                formName: parsedValue.formName || "Registrierung",
                communityData: window.communityData || {},
                
              };

              window.formId = signupFormId;

              window.formCommunityDTO = {
                formId: signupFormId,
                communityIdentifier: null,
              };

              window.draftSubmission = {
                data: {},
              };

              window.submission = window.draftSubmission;
              window.summary = "";

              // =====================================================
              // Formular erzeugen
              // =====================================================
              self.currentForm = Formio.createForm(
  document.getElementById("renderer"),
  self.defItem,
  {
    hooks: {
      beforeNext: (currentPage, submission, next) => {
        try {
          submission.data = submission.data || {};

          window.draftSubmission = submission;
          window.submission = submission;
          window.formDefinition = self.defItem;
          window.currentForm = window.currentForm || parsedValue;

          console.log("[SIGNUP SUMMARY] beforeNext currentPage:", {
            key: currentPage?.component?.key,
            title: currentPage?.component?.title,
          });

          console.log(
            "[SIGNUP SUMMARY] draftSubmission gesetzt:",
            window.draftSubmission
          );
        } catch (e) {
          console.warn(
            "[SIGNUP SUMMARY] beforeNext Vorbereitung fehlgeschlagen:",
            e
          );
        }

        next();
      },
    },

    language: "de",

    i18n: {
  de: {
    error: "Bitte korrigieren Sie die markierten Fehler.",

    next: "Weiter",
    previous: "Zurück",
    cancel: "Abbrechen",
    submit: "Abschicken",

    required: "{{field}} ist ein Pflichtfeld",

    minLength: "{{field}} muss mindestens {{length}} Zeichen lang sein.",
    maxLength: "{{field}} darf höchstens {{length}} Zeichen lang sein.",

    "Value should be longer": "Das Passwort ist zu kurz.",
    "Value should have uppercase letters": "Das Passwort muss mindestens einen Großbuchstaben enthalten.",
    "Value should have lowercase letters": "Das Passwort muss mindestens einen Kleinbuchstaben enthalten.",
    "Value should have numeric symbols": "Das Passwort muss mindestens eine Zahl enthalten.",
    "Value should have symbols": "Das Passwort muss mindestens ein Sonderzeichen enthalten.",
    "Password is not strong enough": "Das Passwort ist nicht stark genug."
  }
}
  }
)
                .then(function (form) {
                  self.viewListComponentKey = moment().format("x");

                  window.form = form;
                  window.formDefinition = form.schema || self.defItem;
                  window.currentForm = window.currentForm || parsedValue;
                  window.draftSubmission = form.submission || { data: {} };
                  window.submission = window.draftSubmission;

const escapeHtml = function (value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
};

const isEmptySummaryValue = function (value) {
  return (
    value === null ||
    value === undefined ||
    value === "" ||
    (Array.isArray(value) && value.length === 0)
  );
};

const getDisplayValue = function (value) {
  if (isEmptySummaryValue(value)) {
    return "";
  }

  if (Array.isArray(value)) {
    return value
      .map((v) => getDisplayValue(v))
      .filter((v) => v !== "")
      .join(", ");
  }

  if (typeof value === "object") {
    if (value.label) return value.label;
    if (value.title) return value.title;
    if (value.name) return value.name;
    if (value.value) return value.value;
    if (value.text) return value.text;

    try {
      return Object.keys(value)
        .filter((k) => value[k] !== null && value[k] !== undefined && value[k] !== "")
        .map((k) => `${k}: ${getDisplayValue(value[k])}`)
        .join(", ");
    } catch (e) {
      return JSON.stringify(value);
    }
  }

  if (typeof value === "boolean") {
    return value ? "Ja" : "Nein";
  }

  return String(value);
};

const collectSummaryRows = function (components, data, rows, currentPageTitle) {
  if (!Array.isArray(components)) return;

  components.forEach((component) => {
    if (!component) return;

    const type = component.type;
    const key = component.key;

    // Nicht anzeigen
    const ignoredTypes = [
      "button",
      "summary",
      "htmlelement",
      "content",
      "hidden",
      "panel",
      "columns",
      "fieldset",
      "well"
    ];

    // Container rekursiv durchsuchen
    if (Array.isArray(component.components)) {
      collectSummaryRows(component.components, data, rows, component.title || currentPageTitle);
      return;
    }

    if (Array.isArray(component.columns)) {
      component.columns.forEach((col) => {
        collectSummaryRows(col.components || [], data, rows, currentPageTitle);
      });
      return;
    }

    if (!key || ignoredTypes.includes(type)) {
      return;
    }

    if (component.hidden === true) {
      return;
    }

    const value = data ? data[key] : undefined;

    if (isEmptySummaryValue(value)) {
      return;
    }

    const label =
      component.label ||
      component.title ||
      component.placeholder ||
      key;

    const displayValue = getDisplayValue(value);

    if (displayValue === "") {
      return;
    }

    rows.push({
      pageTitle: currentPageTitle || "",
      label: label,
      value: displayValue
    });
  });
};

const buildSignupSummaryHtml = function () {
  const schema = form.schema || self.defItem || {};
  const submission = form.submission || window.draftSubmission || { data: {} };
  const data = submission.data || {};

  const rows = [];

  (schema.components || []).forEach((page) => {
    if (!page || page.key === "page8" || page.title === "Zusammenfassung") {
      return;
    }

    collectSummaryRows(
      page.components || [],
      data,
      rows,
      page.title || page.label || ""
    );
  });

  if (rows.length === 0) {
    return "<div class=\"alert alert-warning\">Es liegen keine Daten für die Zusammenfassung vor.</div>";
  }

  let html = "";
  let lastPageTitle = null;

  rows.forEach((row) => {
    if (row.pageTitle && row.pageTitle !== lastPageTitle) {
      if (lastPageTitle !== null) {
        html += "</tbody></table>";
      }

      html += `<h4>${escapeHtml(row.pageTitle)}</h4>`;
      html += `
        <table border="1" cellpadding="10px" style="border-collapse: collapse; width: 100%; margin-bottom: 20px;">
          <tbody>
      `;

      lastPageTitle = row.pageTitle;
    }

    html += `
      <tr>
        <td style="width: 350px;"><strong>${escapeHtml(row.label)}</strong></td>
        <td>${escapeHtml(row.value)}</td>
      </tr>
    `;
  });

  if (lastPageTitle !== null) {
    html += "</tbody></table>";
  }

  return `<div id="summaryContainer" class="summaryContainer">${html}</div>`;
};


const renderSignupSummaryTemplate = function (source) {
  try {
    const summaryData = document.getElementById("summaryData");

    if (!summaryData) {
      console.warn(
        "[SIGNUP SUMMARY TEMPLATE] summaryData nicht gefunden bei:",
        source
      );
      return false;
    }

    if (!self.summaryTemplateHtml) {
      console.warn(
        "[SIGNUP SUMMARY TEMPLATE] Kein Summary-Template geladen bei:",
        source
      );
      return false;
    }

    window.draftSubmission =
      form.submission || window.draftSubmission || { data: {} };

    window.submission = window.draftSubmission;
    window.formDefinition = form.schema || self.defItem;

    const rawTemplateData =
  (form.submission && form.submission.data) ||
  (window.draftSubmission && window.draftSubmission.data) ||
  {};

const templateData = {
  ...rawTemplateData,
};

// Schutz für Bundesland
if (!templateData.land) {
  templateData.land = {
    Value: {
      regionName: "",
    },
  };
}

if (!templateData.land.Value) {
  templateData.land.Value = {
    regionName: "",
  };
}

// Schutz für Gemeinde
if (!templateData.community) {
  templateData.community = {
    Value: "{}",
  };
}

if (!templateData.community.Value) {
  templateData.community.Value = "{}";
}

if (typeof templateData.community.Value === "object") {
  templateData.community.Value = JSON.stringify(templateData.community.Value);
}

    summaryData.innerHTML = "";

    const mountTarget = document.createElement("div");
    mountTarget.id = "signup-summary-template-rendered";
    mountTarget.className = "summaryContainer";
    summaryData.appendChild(mountTarget);

    const compSpec = {
      ...compiler.compileToFunctions(self.summaryTemplateHtml),

      data: () => ({
        templateData: templateData,
        communityData: window.communityData || {},
      }),

      methods: {
        formatDate(date, format = "DD.MM.YYYY") {
          return moment(date).format(format);
        },

        formatTime(date, format = "HH:mm") {
          return moment(date, "YYYY-MM-DD HH:mm:ss").format(format);
        },

        safeJsonParse(value) {
          try {
            return typeof value === "string" ? JSON.parse(value) : value;
          } catch (e) {
            return {};
          }
        },
      },
    };

    if (
      self.summaryTemplateComponent &&
      self.summaryTemplateComponent.$destroy
    ) {
      self.summaryTemplateComponent.$destroy();
      self.summaryTemplateComponent = null;
    }

    const SummaryTemplateComponent = Vue.extend(compSpec);
    self.summaryTemplateComponent = new SummaryTemplateComponent();

    self.summaryTemplateComponent.$mount(mountTarget);

    window.summary = summaryData.innerHTML;

    console.log(
      "[SIGNUP SUMMARY TEMPLATE] Template gerendert bei:",
      source,
      window.summary
    );

    return true;
  } catch (e) {
    console.warn(
      "[SIGNUP SUMMARY TEMPLATE] Rendern fehlgeschlagen bei " + source + ":",
      e
    );

    return false;
  }
};


const captureSignupSummary = function (source) {
  try {
    const renderedFromTemplate = renderSignupSummaryTemplate(source);

    if (renderedFromTemplate) {
      return true;
    }

    const summaryData = document.getElementById("summaryData");

    if (summaryData) {
      const summaryHtml = buildSignupSummaryHtml();

      summaryData.innerHTML = summaryHtml;
      window.summary = summaryHtml;

      console.log(
        "[SIGNUP SUMMARY] Fallback-Summary befüllt bei:",
        source,
        window.summary
      );

      return true;
    }

    const summaryContainer =
      document.getElementById("summaryContainer") ||
      document.querySelector(".summaryContainer");

    if (summaryContainer && summaryContainer.innerHTML.trim()) {
      window.summary = summaryContainer.outerHTML || summaryContainer.innerHTML;

      console.log(
        "[SIGNUP SUMMARY] summaryContainer gelesen bei:",
        source,
        window.summary
      );

      return true;
    }

    console.warn(
      "[SIGNUP SUMMARY] weder summaryData noch summaryContainer gefunden bei:",
      source
    );

    return false;
  } catch (e) {
    console.warn("[SIGNUP SUMMARY] capture failed bei " + source + ":", e);
    return false;
  }
};

                  form.nosubmit = false;

                  

                  // =====================================================
                  // Seitenwechsel: Submission und Definition aktualisieren
                  // =====================================================
                  form.on("nextPage", function (submission) {
                    try {
                      if (submission && submission.data) {
                        window.draftSubmission = submission;
                        window.submission = submission;
                      } else {
                        window.draftSubmission = form.submission || {
                          data: {},
                        };
                        window.submission = window.draftSubmission;
                      }

                      window.formDefinition = form.schema || self.defItem;
                      window.currentForm = window.currentForm || parsedValue;

                      if (typeof form.saveDraft === "function") {
                        form.saveDraft();
                      }

                      console.log(
                        "[SIGNUP SUMMARY] nextPage draftSubmission:",
                        window.draftSubmission
                      );

                    setTimeout(() => {
  try {
    window.draftSubmission =
      form.submission || window.draftSubmission || { data: {} };

    window.submission = window.draftSubmission;
    window.formDefinition = form.schema || self.defItem;

    captureSignupSummary("nextPage");
  } catch (e) {
    console.warn("[SIGNUP SUMMARY] nextPage summary read failed:", e);
  }
}, 500);
                    } catch (e) {
                      console.warn("[SIGNUP SUMMARY] nextPage failed:", e);
                    }
                  });

                  // =====================================================
                  // Render-Event: Summary erneut prüfen
                  // =====================================================
                  form.on("render", function () {
                    try {
                      window.formDefinition = form.schema || self.defItem;
                      window.currentForm = window.currentForm || parsedValue;
                      window.draftSubmission =
                        form.submission || window.draftSubmission || {
                          data: {},
                        };
                      window.submission = window.draftSubmission;

                      setTimeout(() => {
  window.draftSubmission =
    form.submission || window.draftSubmission || { data: {} };

  window.submission = window.draftSubmission;
  window.formDefinition = form.schema || self.defItem;

  const summaryData = document.getElementById("summaryData");

  if (summaryData) {
    captureSignupSummary("render");
  }
}, 500);
                    } catch (e) {
                      console.warn("[SIGNUP SUMMARY] render handler failed:", e);
                    }
                  });

                  // =====================================================
                  // Change-Event: aktuelle Daten global spiegeln
                  // =====================================================
                  form.on("change", function () {
                    try {
                      window.draftSubmission =
                        form.submission || window.draftSubmission || {
                          data: {},
                        };

                      window.submission = window.draftSubmission;
                      window.formDefinition = form.schema || self.defItem;
                      window.currentForm = window.currentForm || parsedValue;
                    } catch (e) {
                      console.warn("[SIGNUP SUMMARY] change handler failed:", e);
                    }
                  });

                  // =====================================================
                  // Submit nicht an Form.io schicken
                  // =====================================================
                  form.nosubmit = true;

                  // =====================================================
                  // Submit Registrierung
                  // =====================================================
                 // =====================================================
// Submit Registrierung
// =====================================================
form.on("submit", function (submission) {
  try {
    captureSignupSummary("submit");

    if (!window.summary) {
      console.warn("SIGNUP submit: summary konnte nicht erzeugt werden");
      window.summary = "";
    }

    let formValue = {};

    submission.data = submission.data || {};

    // =====================================================
    // Signup: E-Mail / Verifizierungsstatus absichern
    // =====================================================
    try {
      const emailCheckWrapper = submission.data.emailCheckWrapper || {};

      const nestedEmailData =
        emailCheckWrapper.data ||
        (
          emailCheckWrapper.form &&
          emailCheckWrapper.form.data
            ? emailCheckWrapper.form.data
            : null
        ) ||
        emailCheckWrapper.form ||
        {};

      const verifiedEmail =
        nestedEmailData.userMail ||
        nestedEmailData.textField ||
        (
          nestedEmailData.check &&
          nestedEmailData.check.email
            ? nestedEmailData.check.email
            : null
        ) ||
        submission.data.userMail ||
        submission.data.eMail ||
        "";

      if (verifiedEmail) {
        submission.data.eMail = verifiedEmail;
        submission.data.userMail = verifiedEmail;
      }

      const isVerified =
        nestedEmailData.isVerified === true ||
        nestedEmailData.emailVerified === true ||
        (
          nestedEmailData.checkToken &&
          nestedEmailData.checkToken.success === true
        ) ||
        nestedEmailData.verifizieren === true ||
        submission.data.isVerified === true ||
        submission.data.emailVerified === true;

      submission.data.isVerified = isVerified;
      submission.data.emailVerified = isVerified;

      console.log("[SIGNUP SUBMIT] email normalized:", {
        verifiedEmail: verifiedEmail,
        isVerified: isVerified,
        nestedEmailData: nestedEmailData,
        finalEmail: submission.data.eMail
      });
    } catch (emailNormalizeError) {
      console.warn(
        "[SIGNUP SUBMIT] E-Mail-Normalisierung fehlgeschlagen:",
        emailNormalizeError
      );

      submission.data.isVerified = submission.data.isVerified === true;
      submission.data.emailVerified = submission.data.emailVerified === true;
    }

    // =====================================================
    // Signup: störende / unnötige Felder entfernen
    // =====================================================
    delete submission.data.passwortWiederholen;

    if (
      submission.data.emailCheckWrapper &&
      submission.data.emailCheckWrapper.form === ""
    ) {
      delete submission.data.emailCheckWrapper;
    }

    // =====================================================
    // Signup: Summary und Payload setzen
    // =====================================================
    formValue.summary = window.summary || "";
    submission.summary = window.summary || "";
    formValue.value = JSON.stringify(submission);

    console.log("[SIGNUP SUBMIT] final submission:", submission);
    console.log("[SIGNUP SUBMIT] formValue:", formValue);

    axios({
  method: "post",
  url: config.API_URL + "/api/signup",
  data: formValue,
  headers: {
    "Content-Type": "application/json"
  },
  validateStatus: function () {
    return true;
  }
})
  .then((response) => {
    console.log("SIGNUP RAW response:", response);

    const debugInfo = {
      status: response ? response.status : null,
      statusText: response ? response.statusText : null,
      responseData: response ? response.data : null,
      responseHeaders: response ? response.headers : null,
      requestUrl:
        response && response.request
          ? response.request.responseURL
          : null,
      formValue: formValue
    };

    localStorage.setItem(
      "signup_last_response",
      JSON.stringify(debugInfo, null, 2)
    );
    
if (response && response.status >= 200 && response.status < 300) {
  self.$root.$children[0].showMessage(
    "Gespeichert",
    "Daten gespeichert",
    "success"
  );

  try {
    localStorage.removeItem("ozgJwt");
    delete axios.defaults.headers.common["Authorization"];
  } catch (e) {}

  window.location.href =
    window.location.origin +
    "/widget/signup-thankyou.html";

  return;
}

    console.error("SIGNUP failed with backend response:", debugInfo);

    alert(
      "Signup fehlgeschlagen.\n\n" +
      "Status: " + debugInfo.status + "\n" +
      "StatusText: " + debugInfo.statusText + "\n\n" +
      "Backend-Response wurde in localStorage unter signup_last_response gespeichert."
    );

    self.$root.$children[0].showMessage(
      "Fehler",
      debugInfo.responseData
        ? JSON.stringify(debugInfo.responseData)
        : "Die Registrierung konnte nicht gespeichert werden. Status: " + debugInfo.status,
      "danger"
    );
  })
  .catch((e) => {
    console.error("SIGNUP /api/signup technical failed:", e);

    const debugInfo = {
      message: e && e.message ? e.message : null,
      status: e && e.response ? e.response.status : null,
      statusText: e && e.response ? e.response.statusText : null,
      responseData: e && e.response ? e.response.data : null,
      responseHeaders: e && e.response ? e.response.headers : null,
      requestUrl:
        e && e.response && e.response.request
          ? e.response.request.responseURL
          : null,
      formValue: formValue
    };

    localStorage.setItem(
      "signup_last_error",
      JSON.stringify(debugInfo, null, 2)
    );

    alert(
      "Signup technisch fehlgeschlagen.\n\n" +
      "Status: " + debugInfo.status + "\n" +
      "StatusText: " + debugInfo.statusText
    );
  });
  } catch (e) {
    console.error("[SIGNUP SUBMIT] Fehler:", e);

    self.$root.$children[0].showMessage(
      "Fehler",
      "Beim Absenden ist ein Fehler aufgetreten.",
      "danger"
    );
  }
            });
          })
          .catch((e) => {
            console.log(e);
          });
      });
  },
};

</script>

